import { getBrochureApiUrl } from '../utils/brochureApiConfig';
import { isCdSite } from '../utils/siteConfig';

export interface ContactConsultationPayload {
  name: string;
  email: string;
  message: string;
}

export type LocationContactLocation = 'kinshasa' | 'lubumbashi';

export interface LocationContactPayload {
  location: LocationContactLocation;
  fullName: string;
  email: string;
  phone: string;
  company?: string;
  message: string;
}

export const submitConsultationRequest = async (payload: ContactConsultationPayload) => {
  const response = await fetch(`${getBrochureApiUrl()}/api/contact-consultation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'omit',
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.message || 'Failed to submit consultation request');
  }

  return response.json();
};

export const submitLocationContactRequest = async (payload: LocationContactPayload) => {
  if (!isCdSite()) {
    throw new Error('Location contact is only available on coolcare.cd.');
  }

  const response = await fetch(`${getBrochureApiUrl()}/api/location-contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'omit',
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.message || 'Failed to submit contact request');
  }

  return response.json();
};
